import { render, staticRenderFns } from "./SelectXhrComponent.vue?vue&type=template&id=0ae24e20&scoped=true"
import script from "./SelectXhrComponent.vue?vue&type=script&lang=js"
export * from "./SelectXhrComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectXhrComponent.vue?vue&type=style&index=0&id=0ae24e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae24e20",
  null
  
)

export default component.exports